export var TypeActionPendingInventoryInfo;
(function (TypeActionPendingInventoryInfo) {
    TypeActionPendingInventoryInfo["Received"] = "PendingInventoryInfo > Received";
    TypeActionPendingInventoryInfo["RequestUpdate"] = "PendingInventoryInfo > RequestUpdate";
    TypeActionPendingInventoryInfo["CollectRewards"] = "PendingInventoryInfo > CollectRewards";
})(TypeActionPendingInventoryInfo || (TypeActionPendingInventoryInfo = {}));
export var actionPendingInventoryInfoReceived = function (props) { return ({
    pendingInventoryInfo: props,
    type: TypeActionPendingInventoryInfo.Received,
}); };
export var actionUpdatePendingInventory = function (playerId) { return ({
    playerId: playerId,
    type: TypeActionPendingInventoryInfo.RequestUpdate,
}); };
export var actionPendingInventoryCollectRewards = function (transferId) { return ({
    transferId: transferId,
    type: TypeActionPendingInventoryInfo.CollectRewards,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/pending-inventory/actionPendingInventoryInfo.ts
// module id = 295
// module chunks = 3